import { AccidentQuestionResponse } from "../reducers/reducer-accident-questions";
import { refreshReducersToInitial } from "./refreshData-action";

export const UPDATE_ACCIDENT_QUESTIONS = "UPDATE_ACCIDENT_QUESTIONS" as const;

export const updateAccidentQuestions = (payload: AccidentQuestionResponse) => ({
  type: UPDATE_ACCIDENT_QUESTIONS,
  payload,
});

export type AccidentQuestionActions = ReturnType<typeof updateAccidentQuestions> | ReturnType<typeof refreshReducersToInitial>;